export enum TaskStatuses {
  ACTIVE = 'active',
  WAIT = 'wait',
  FAILURE = 'failure',
  SUCCESS = 'success',
  RESERVED = 'reserved'
}
